import React from "react";
import LineChartWidget from "./charts/LineChartWidget";
import BarChartWidget from "./charts/BarChartWidget";
import NumberCardWidget from "./charts/NumberCardWidget";
import GaugeWidget from "./charts/GaugeWidget";
import TableWidget from "./charts/TableWidget";
import PieChartWidget from "./charts/PieChartWidget";

const widgetMap = {
    line: LineChartWidget,
    bar: BarChartWidget,
    number: NumberCardWidget,
    gauge: GaugeWidget,
    table: TableWidget,
    pie: PieChartWidget,
};

const CARD_BODY_HEIGHT = 220;

export default function WidgetRenderer({ widget, data, latestTags, loading, error, fullscreen }) {
    const {
        visualization = "line",
        granularity = "hour",
        displayConfig = {},
    } = widget;

    const ChartComponent = widgetMap[visualization] || widgetMap.line;
    const bodyHeight = fullscreen ? "100%" : CARD_BODY_HEIGHT;

    if (fullscreen) {
        return (
            <div style={{ width: "100%", height: "100%" }}>
                {loading && <div style={{ color: "var(--admin_neutral_3, #94a3b8)", textAlign: "center", padding: "2rem" }}>Loading...</div>}
                {error && <div style={{ color: "#ef4444", textAlign: "center", padding: "2rem" }}>Error: {error}</div>}
                {!loading && !error && (
                    <ChartComponent data={data} granularity={granularity} label={displayConfig.title || widget.kpi}
                        color={displayConfig.color || "#6366f1"} target={displayConfig.target}
                        tagKey={widget.groupByTag || undefined} latestTags={latestTags} fullscreen />
                )}
            </div>
        );
    }

    return (
        <div style={{
            minHeight: bodyHeight,
            height: bodyHeight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
        }}>
            {loading && (
                <div style={{ color: "var(--admin_neutral_3, #94a3b8)" }}>Loading...</div>
            )}
            {error && (
                <div style={{ color: "#ef4444" }}>Error: {error}</div>
            )}
            {!loading && !error && (
                <ChartComponent
                    data={data}
                    granularity={granularity}
                    label={displayConfig.title || widget.kpi}
                    color={displayConfig.color || "#6366f1"}
                    target={displayConfig.target}
                    tagKey={widget.groupByTag || undefined}
                    latestTags={latestTags}
                    fullscreen={fullscreen}
                />
            )}
        </div>
    );
}
